const agriculture_data = {
  title: `Agricultural Worksite Profiles`,
  body: `Select the Agricultural Worksite profile(s) to populate in the Addendum B table.`,
  table: {
    th: ["Name of Agricultural Business", "State", "County"],
    td: ["agriculture_emp_name", "agriculture_state", "agriculture_county"],
  },
  new_profile(profile) {
    return {
      id: profile.id,
      agriculture_emp_name: profile.agriculture_emp_name,
      agriculture_address: null,
      agriculture_city: null,
      agriculture_state: profile.agriculture_state,
      agriculture_county: profile.agriculture_county,
      agriculture_zip: null,
      agriculture_additional_info: null,
      agriculture_begin_date: null,
      agriculture_end_date: null,
      agriculture_total_workers: null,
    };
  },
};

export default agriculture_data;
